import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchBillingAddresses } from '#/modules/orgDashboard/api/billingAddress/orgDashboardApiFetchBillingAddress';
import { orgDashboardApiIsomorphicFetchInvoice } from '#/modules/orgDashboard/api/invoice/orgDashboardApiClientFetchInvoice';
import { orgDashboardInvoiceBillingAddressRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardInvoiceBillingAddressContainerLoadable } from './OrgDashboardInvoiceBillingAddressContainerLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId, invoiceId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardInvoiceBillingAddressRoute>) {
  const [{ invoice }, billingAddresses] = await Promise.all([
    orgDashboardApiIsomorphicFetchInvoice({ request, context })(
      orgId,
      invoiceId,
    ),
    orgDashboardApiIsomorphicFetchBillingAddresses({ request, context })(orgId),
    OrgDashboardInvoiceBillingAddressContainerLoadable.load(),
  ]);

  return { invoice, billingAddresses };
}

export default function OrgDashboardInvoiceBillingAddressHorizonRoute({
  loaderData: { invoice, billingAddresses },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Change Invoice Address')}>
      <OrgDashboardInvoiceBillingAddressContainerLoadable
        invoice={invoice}
        initialBillingAddresses={billingAddresses}
      />
    </RouteModule>
  );
}
